import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';

const namespace = 'CREATE_ASSOCIATED_ACCOUNT';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
